export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/array.js
// module id = ./node_modules/d3-shape/src/array.js
// module chunks = 54